import { createAsyncThunk } from '@reduxjs/toolkit';

import type { Fatura } from '@/features/faturas/types';

import type {
  AntecipacaoPagamentoFormData,
  AntecipacaoPagamentoResultado,
  ConsumoEmAberto,
  Estorno,
  PainelFinanceiroResumo,
} from '../types';
import { financeiroEscritorioService } from './services';

export const fetchPainelResumo = createAsyncThunk<PainelFinanceiroResumo>(
  'financeiroEscritorio/fetchResumo',
  async (_, { rejectWithValue }) => {
    try {
      return await financeiroEscritorioService.fetchResumo();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchFaturasEscritorio = createAsyncThunk<Fatura[]>(
  'financeiroEscritorio/fetchFaturas',
  async (_, { rejectWithValue }) => {
    try {
      return await financeiroEscritorioService.fetchFaturas();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchFaturaEscritorioById = createAsyncThunk<Fatura, string>(
  'financeiroEscritorio/fetchFaturaById',
  async (faturaId, { rejectWithValue }) => {
    try {
      return await financeiroEscritorioService.fetchFaturaById(faturaId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchConsumoEmAberto = createAsyncThunk<ConsumoEmAberto[]>(
  'financeiroEscritorio/fetchConsumoEmAberto',
  async (_, { rejectWithValue }) => {
    try {
      return await financeiroEscritorioService.fetchConsumoEmAberto();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const gerarFaturaAntecipada = createAsyncThunk<
  AntecipacaoPagamentoResultado,
  AntecipacaoPagamentoFormData
>('financeiroEscritorio/gerarFaturaAntecipada', async (data, { rejectWithValue }) => {
  try {
    return await financeiroEscritorioService.gerarFaturaAntecipada(data);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const fetchEstornos = createAsyncThunk<Estorno[]>(
  'financeiroEscritorio/fetchEstornos',
  async (_, { rejectWithValue }) => {
    try {
      return await financeiroEscritorioService.fetchEstornos();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
